import React from 'react'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  UI_COLOR_BORDER_LIGHT,
  UI_COLOR_DANGER_TEXT,
  UI_COLOR_SUCCESS_SOFT,
  UI_COLOR_SUCCESS_TEXT,
  UI_COLOR_TEXT_SUBTITLE
} from '../../constants/uiColors'
import { getPasswordRequirements, getPasswordValidationState } from './passwordValidation'

function RequirementChip({ met, label }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.6,
        borderRadius: '999px',
        backgroundColor: met ? UI_COLOR_SUCCESS_SOFT : '#FDECEC',
        color: met ? UI_COLOR_SUCCESS_TEXT : UI_COLOR_DANGER_TEXT,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }}
    >
      {met ? (
        <CheckCircleOutlineRoundedIcon sx={{ fontSize: 16 }} />
      ) : (
        <RadioButtonUncheckedRoundedIcon sx={{ fontSize: 16 }} />
      )}
      {label}
    </Box>
  )
}

function RequirementRow({ met, label }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      {met ? (
        <CheckCircleOutlineRoundedIcon sx={{ fontSize: 18, color: UI_COLOR_SUCCESS_TEXT }} />
      ) : (
        <RadioButtonUncheckedRoundedIcon sx={{ fontSize: 18, color: UI_COLOR_DANGER_TEXT }} />
      )}
      <Typography
        sx={{
          fontSize: 13.5,
          lineHeight: 1.4,
          color: met ? UI_COLOR_SUCCESS_TEXT : UI_COLOR_DANGER_TEXT
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default function PasswordRulesPanel({
  password = '',
  passwordConfirmation = '',
  showWhenEmpty = false
}) {
  const checks = getPasswordValidationState(password, passwordConfirmation)
  const requirements = getPasswordRequirements(password, passwordConfirmation)
  const hasStartedPassword = password.length > 0
  const hasStartedConfirmation = passwordConfirmation.length > 0

  if (!showWhenEmpty && !hasStartedPassword) return null

  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <RequirementChip met={checks.length} label="8 a 15 caracteres" />
        {hasStartedConfirmation ? <RequirementChip met={checks.match} label="Coinciden" /> : null}
      </Stack>

      <Box
        sx={{
          p: 1.75,
          borderRadius: '16px',
          border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
          backgroundColor: '#FAFBFC'
        }}
      >
        <Typography
          sx={{
            mb: 1.25,
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: UI_COLOR_TEXT_SUBTITLE
          }}
        >
          Reglas de la contraseña
        </Typography>
        <Stack spacing={0.9}>
          {requirements.map((requirement) => (
            <RequirementRow
              key={requirement.key}
              met={requirement.met}
              label={requirement.label}
            />
          ))}
        </Stack>
      </Box>
    </Stack>
  )
}
